$(window).on('DOMContentLoaded load resize scroll', animateMapsInView);
animateMapsInView();

$('[data-map]').each(function () {
	buildMap(this);
});

function animateMapsInView() {
	$('[data-map-load-on-view]').each(function () {
		
		if ( $(this).hasClass('in-view') ) {
			return;	
		}
		
		if ( isElementInViewport($(this)) ) {
			var elementToAnimate = this;
			
			$(elementToAnimate).addClass('in-view'); // log that this element has been seen
			
			
			setTimeout(function () {
				$(elementToAnimate).addClass( $(elementToAnimate).data('animate-in-view') ); // apply the animation class
			}, 300);
			
			
			if ( typeof $(elementToAnimate).data('map-load-on-view') != 'undefined' ) { // only load this map once it's in view
				buildMap(elementToAnimate);
			}
		}
	});
}

function isElementInViewport (el) {
	if (typeof jQuery === "function" && el instanceof jQuery) {
		el = el[0];
	}
	
	var rect = el.getBoundingClientRect();
	
	var t = rect.y;
	var b = window.innerHeight - rect.y - rect.height;
	var h = window.innerHeight;
	
	if (
		( (t >= 0) && (t <= h) ) ||
		( (b >= 0) && (b <= h) )
	) {
		return true;
	} else {
		return false;
	}
}


function buildMap(theMap) {
	$(theMap).each(function () {
		var map, centerLat, centerLng, zoom, marker, markerLat, markerLng;
		
		if (typeof $(this).data('map-center-coords') != 'undefined') {
			centerLat = parseFloat( $(this).data('map-center-coords').split(',')[0] );
			centerLng = parseFloat( $(this).data('map-center-coords').split(',')[1] );
		} else {
			centerLat = 0;
			centerLng = 0;
		}
		
		// Center the map on the marker when on mobile (i.e. ignore the specified centre coords)
		if (typeof $(this).data('map-marker-coords') !== 'undefined') {
			if ( window.innerWidth <= 640 ) {
				centerLat = parseFloat( $(this).data('map-marker-coords').split(',')[0] );
				centerLng = parseFloat( $(this).data('map-marker-coords').split(',')[1] );
			}
		}
		
		zoom = $(this).data('map-zoom') || 8;
		
		
			map = new google.maps.Map($(this)[0], {
				center: {lat: centerLat, lng: centerLng},
				zoom: zoom,
				zoomControl: true,
				zoomControlOptions: {
					position: google.maps.ControlPosition.LEFT_BOTTOM
				},
				mapTypeControl: false,
				scaleControl: false,
				streetViewControl: false,
				rotateControl: false,
				fullscreenControl: false,
				styles: [{featureType:"all",elementType:"labels",stylers:[{visibility:"on"},{color:"#000000"}]},{featureType:"all",elementType:"labels.text.fill",stylers:[{saturation:36},{color:"#4e6c5e"},{lightness:40}]},{featureType:"all",elementType:"labels.text.stroke",stylers:[{visibility:"off"},{color:"#ffffff"},{lightness:16}]},{featureType:"all",elementType:"labels.icon",stylers:[{visibility:"off"}]},{featureType:"administrative",elementType:"geometry.fill",stylers:[{color:"#fefefe"},{lightness:20}]},{featureType:"administrative",elementType:"geometry.stroke",stylers:[{color:"#fefefe"},{lightness:17},{weight:1.2}]},{featureType:"administrative",elementType:"labels",stylers:[{visibility:"on"},{color:"#424143"}]},{featureType:"administrative",elementType:"labels.text.stroke",stylers:[{visibility:"off"}]},{featureType:"administrative.locality",elementType:"labels",stylers:[{visibility:"on"}]},{featureType:"administrative.locality",elementType:"labels.text.stroke",stylers:[{visibility:"off"}]},{featureType:"landscape",elementType:"geometry",stylers:[{color:"#dee7a4"},{lightness:20}]},{featureType:"landscape",elementType:"labels",stylers:[{visibility:"on"}]},{featureType:"landscape",elementType:"labels.text.stroke",stylers:[{visibility:"off"}]},{featureType:"poi",elementType:"geometry",stylers:[{color:"#f2fcb3"},{lightness:21}]},{featureType:"poi.park",elementType:"geometry",stylers:[{color:"#d2da9a"},{lightness:21}]},{featureType:"road",elementType:"geometry",stylers:[{visibility:"on"}]},{featureType:"road",elementType:"labels",stylers:[{color:"#858585"}]},{featureType:"road",elementType:"labels.text.stroke",stylers:[{visibility:"off"}]},{featureType:"road.highway",elementType:"geometry.fill",stylers:[{color:"#ffffff"},{lightness:17}]},{featureType:"road.highway",elementType:"geometry.stroke",stylers:[{color:"#ffffff"},{lightness:29},{weight:.2}]},{featureType:"road.arterial",elementType:"all",stylers:[{visibility:"on"}]},{featureType:"road.arterial",elementType:"geometry",stylers:[{color:"#ffffff"},{lightness:18}]},{featureType:"road.arterial",elementType:"labels",stylers:[{visibility:"on"},{color:"#858585"}]},{featureType:"road.arterial",elementType:"labels.text.stroke",stylers:[{visibility:"off"},{color:"#ff0000"}]},{featureType:"road.local",elementType:"geometry",stylers:[{color:"#ffffff"},{lightness:16}]},{featureType:"road.local",elementType:"labels.text.stroke",stylers:[{visibility:"off"}]},{featureType:"transit",elementType:"geometry",stylers:[{color:"#ffffff"},{lightness:19}]},{featureType:"water",elementType:"geometry",stylers:[{lightness:17},{color:"#b4d0de"}]},{featureType:"water",elementType:"labels",stylers:[{visibility:"on"},{color:"#fff9f9"}]},{featureType:"water",elementType:"labels.text.stroke",stylers:[{visibility:"off"}]}]
			});
		
		
	
		if (typeof $(this).data('map-marker-coords') != 'undefined') {
			if (typeof $(this).data('map-marker-coords') != 'undefined') {
				markerLat = parseFloat( $(this).data('map-marker-coords').split(',')[0] );
				markerLng = parseFloat( $(this).data('map-marker-coords').split(',')[1] );
			} else {
				markerLat = 0;
				markerLng = 0;
			}
			
			marker = new google.maps.Marker({
				position: {lat: markerLat, lng: markerLng},
				map: map
			});
			
			if (typeof $(this).data('map-marker-url') != 'undefined') {
				marker.setIcon($(this).data('map-marker-url'));
			}
		}
		
		
		
		
		var markers = [];
		var markersBounds = new google.maps.LatLngBounds();
		var markerCount = 0;
		
		$(this).siblings('[data-map-marker]').each(function () {
			if (typeof $(this).data('map-marker-coords') != 'undefined') {
				markerLat = parseFloat( $(this).data('map-marker-coords').split(',')[0] );
				markerLng = parseFloat( $(this).data('map-marker-coords').split(',')[1] );
			} else {
				markerLat = 0;
				markerLng = 0;
			}
			
			var locationMarker = new google.maps.Marker({
				position: {lat: markerLat, lng: markerLng},
				map: map
			});
			
			locationMarker.setIcon('/assets/img/map-marker.svg');
			locationMarker.isActive = false;
			
			locationMarker.id = markerCount;
			markerCount++;
			
			locationMarker.$popupElement = $(this).find('.locations__popup');
			//console.log(marker.$popupElement);
			
			locationMarker.addListener('click', function() {
				// Set/unset marker state and open/close popups as required
				if (locationMarker.isActive) {
					locationMarker.isActive = false;
					//locationMarker.setIcon('/assets/img/map-marker-location-active.svg');
					
					locationMarker.$popupElement.fadeOut();
					$('.locations__popup-background').fadeOut();
				} else {
					map.panTo(locationMarker.position);
					
					locationMarker.isActive = true;
					//locationMarker.setIcon('/assets/img/map-marker-location-active.svg');
					
					$('.locations__popup').hide();
					locationMarker.$popupElement.fadeIn();
					$('.locations__popup-background').fadeIn();
				}
			});
			
			/*locationMarker.addListener('mouseover', function() {
				if (!locationMarker.isActive) {
					locationMarker.setIcon('/assets/img/map-marker-location-active.svg');
				}
			});
			
			locationMarker.addListener('mouseout', function() {
				if (!locationMarker.isActive) {
					locationMarker.setIcon('/assets/img/map-marker-location.svg');
				}
			});*/
			
			markers.push(locationMarker);
			markersBounds.extend(locationMarker.position);
		});
		
		
		// make sure map fits the marker bounds
		if (markers.length > 0) {
			map.fitBounds(markersBounds);
		}

		// set marker clusterer
		var mapClusterer = new MarkerClusterer(map, markers, {
			gridSize: 17,
			ignoreHidden: true,
			zoomOnClick: false,
			styles: [
				{
					url: '/assets/img/map-marker-cluster.svg',
					width: 32,
					height: 32,
					anchorText: [0, 0],
					anchorIcon: [15, 15],
					textColor: '#fff'
				}
			]
		});
		
		google.maps.event.addListener(mapClusterer, 'clusterclick', function(c) {
			map.fitBounds(c.getBounds());
		});
		
		
		$('.locations__popup-close').on('click', function () {
			$(this).parent().fadeOut();
			$('.locations__popup-background').fadeOut();
			
			for (var m in markers) {
				markers[m].isActive = false;
				markers[m].setIcon('/assets/img/map-marker.svg');
			}
		});
		
	});
}